import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";

// Landing Pages
import Tnc from "@/pages/Tnc.vue";
import ReviewerTnc from "@/pages/Dashboard/FlightReviewer/ReviewerTnc.vue";
import Privacy from "@/pages/Privacy.vue";
import ForgotPassword from "@/pages/Landing/ForgotPasswords.vue";
import Signup from "@/pages/Signup.vue";
import Login from "@/pages/Login.vue";
import Signup_fr from "@/pages/Signup_fr.vue";
import Login_fr from "@/pages/Login_fr.vue";
// import DevLandingPagesPlaceholder from "@/pages/Landing/DevLandingPagesPlaceholder.vue";
import UnsubscribeNewsletter from "@/pages/Landing/UnsubscribeNewsletter.vue";
import Index from "@/pages/Index.vue";
import Pricing from "@/pages/Landing/Pricing.vue";
import Product from "@/pages/Landing/Product.vue";
import Home from "@/pages/Landing/Home.vue";
import ContactUs from "@/pages/Landing/ContactUs.vue";
import PilotNetwork from "@/pages/Landing/PilotNetwork.vue";

// Dashboard pages
import Dashboard from "@/pages/Dashboard/Dashboard.vue";
import Map from "@/pages/Dashboard/Map.vue";
import AirportMap from "@/pages/Dashboard/AirportMap.vue";
import Notice from "@/pages/Dashboard/Notice.vue";
import Contact from "@/pages/Dashboard/Contact.vue";
import UserProfile from "@/pages/Dashboard/Pages/UserProfile.vue";
import Subscription from "@/pages/Dashboard/Subscription.vue";
import NewSurvey from "@/pages/Dashboard/NewSurvey.vue";
import Mission from "@/pages/Dashboard/OldSurvey.vue";

import CFS from "@/pages/Dashboard/CFS.vue";
import VFR from "@/pages/Dashboard/VFR.vue";
import SMS from "@/pages/Dashboard/SMS.vue";

// Flight reviewer pages
import Offering from "@/pages/Dashboard/FlightReviewer/Offering.vue";
import Calendar from "@/pages/Dashboard/FlightReviewer/Calendar.vue";
import Booking from "@/pages/Dashboard/FlightReviewer/Booking.vue";
import BookingList from "@/pages/Dashboard/FlightReviewer/BookingList.vue";
import ReviewerBookingList from "@/pages/Dashboard/FlightReviewer/ReviewerBookingList.vue";
import ReviewerFeedback from "@/pages/Dashboard/FlightReviewer/ReviewerFeedback.vue";
import Reschedule from "@/pages/Dashboard/FlightReviewer/Reschedule.vue";
import Requirement from "@/pages/Dashboard/FlightReviewer/Requirement.vue";

// Setting Pages
import Pilot from "@/pages/Dashboard/Settings/Pilot.vue";
import Drone from "@/pages/Dashboard/Settings/Drone.vue";
import Projects from "@/pages/Dashboard/Settings/Projects.vue";
import Checklist from "@/pages/Dashboard/Settings/Checklist.vue";

import Users from "@/pages/Dashboard/Admin/Users.vue";
import Drones from "@/pages/Dashboard/Admin/Drones.vue";
import Radar from "@/pages/Dashboard/Admin/Radar.vue";
// import { LANDING_BASE_URL } from "@/helpers";

const flightReviewerMenu = {
  path: "/flight-review",
  component: DashboardLayout,
  name: "flightReviewerMenu",
  redirect: "/flight-review/offering",
  children: [
    {
      path: "offering",
      name: "offering",
      components: {
        default: Offering
      }
    },
    {
      path: "calendar",
      name: "calendar",
      components: {
        default: Calendar
      }
    },
    {
      path: "booking",
      name: "booking",
      components: {
        default: Booking
      }
    },
    {
      path: "bookingList",
      name: "bookingList",
      components: {
        default: BookingList
      }
    },
    {
      path: "reviewerBookingList",
      name: "reviewerBookingList",
      components: {
        default: ReviewerBookingList
      }
    },
    {
      path: "reviewerFeedback",
      name: "reviewerFeedback",
      components: {
        default: ReviewerFeedback
      }
    },
    {
      path: "reschedule",
      name: "reschedule",
      components: {
        default: Reschedule
      }
    },
    {
      path: "requirement",
      name: "requirement",
      components: {
        default: Requirement
      }
    }
  ]
};

let settingsMenu = {
  path: "/settings",
  component: DashboardLayout,
  name: "Settings",
  redirect: "/settings/pilot",
  children: [
    {
      path: "projects",
      name: "Projects",
      components: {
        default: Projects
      }
    },
    {
      path: "drone",
      name: "RPAS",
      components: {
        default: Drone
      }
    },
    {
      path: "pilot",
      name: "Pilots",
      components: {
        default: Pilot
      }
    },
    {
      path: "checklist",
      name: "Checklists",
      components: {
        default: Checklist
      }
    }
  ]
};

const adminMenu = {
  path: "/admin",
  component: DashboardLayout,
  name: "Administration",
  redirect: "/admin/users",
  children: [
    {
      path: "users",
      name: "Users List",
      components: {
        default: Users
      }
    },
    {
      path: "drones",
      name: "RPAS List",
      components: {
        default: Drones
      }
    },
    {
      path: "radar",
      name: "Radar Map",
      components: {
        default: Radar
      }
    }
  ]
};

const routes = [
  // {
  //   path: "/",
  //   name: "Home",
  //   component: DevLandingPagesPlaceholder
  //   // beforeEnter(to, from, next) {
  //   //   if (
  //   //     process.env.NODE_ENV !== "development" &&
  //   //     window.location.hostname !== "testdashboard.rpaswilco.com"
  //   //   ) {
  //   //     window.location.href = LANDING_BASE_URL;
  //   //   }

  //   //   next();
  //   // }
  // },
  // {
  //   path: "/pricing",
  //   name: "Pricing",
  //   component: DevLandingPagesPlaceholder
  //   // beforeEnter(to, from, next) {
  //   //   if (
  //   //     process.env.NODE_ENV !== "development" &&
  //   //     window.location.hostname !== "testdashboard.rpaswilco.com"
  //   //   ) {
  //   //     window.location.href = `${LANDING_BASE_URL}/pricing`;
  //   //   }

  //   //   next();
  //   // }
  // },
  {
    path: "/",
    component: Index,
    children: [
      {
        path: "/",
        name: "Home",
        components: {
          default: Home
        }
      },
      {
        path: "/pricing",
        name: "Pricing",
        components: {
          default: Pricing
        }
      },
      {
        path: "/product",
        name: "Product",
        components: {
          default: Product
        }
      },
      {
        path: "/contactus",
        name: "Contactus",
        components: {
          default: ContactUs
        }
      },
      {
        path: "/signup",
        name: "Signup",
        components: {
          default: Signup
        }
      },
      {
        path: "/login",
        name: "Login",
        components: {
          default: Login
        }
      },
      {
        path: "/flight-review/map",
        name: "PilotNetwork",
        components: {
          default: PilotNetwork
        }
      }
    ],
    props: {
      header: {
        colorOnScroll: 400,
        navbarTransparent: true
      }
    }
  },
  {
    path: "/tnc",
    name: "TnC",
    components: {
      default: Tnc
    }
  },
  {
    path: "/reviewerTnc",
    name: "ReviewerTnc",
    components: {
      default: ReviewerTnc
    }
  },
  {
    path: "/privacy",
    name: "Privacy",
    components: {
      default: Privacy
    }
  },
  {
    path: "/forgotpassword",
    name: "ForgotPassword",
    components: {
      default: ForgotPassword
    }
  },
  {
    path: "/signup_fr",
    name: "Signup_fr",
    components: {
      default: Signup_fr
    }
  },
  {
    path: "/login_fr",
    name: "Login_fr",
    components: {
      default: Login_fr
    }
  },
  {
    path: "/unsubscribe-newsletter",
    name: "Unsubscribe from Newsletter",
    components: {
      default: UnsubscribeNewsletter
    }
  },
  flightReviewerMenu,
  settingsMenu,
  adminMenu,
  {
    path: "/",
    component: DashboardLayout,
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        components: {
          default: Dashboard
        }
      },
      {
        path: "profile",
        name: "User Profile",
        components: {
          default: UserProfile
        }
      },
      {
        path: "subscription",
        name: "Subscription",
        components: {
          default: Subscription
        }
      },
      {
        path: "map",
        name: "Map",
        components: {
          default: Map
        }
      },
      {
        path: "airportmap",
        name: "AirportMap",
        components: {
          default: AirportMap
        }
      },
      {
        path: "notice",
        name: "Notice",
        components: {
          default: Notice
        }
      },
      {
        path: "newsurvey",
        name: "New Site Surveys",
        components: {
          default: NewSurvey
        }
      },
      {
        path: "mission",
        name: "Missions",
        components: {
          default: Mission
        }
      },
      {
        path: "sms",
        name: "SMS",
        components: {
          default: SMS
        }
      },
      {
        path: "cfs",
        name: "CFS",
        components: {
          default: CFS
        }
      },
      {
        path: "vfr",
        name: "VFR Charts",
        components: {
          default: VFR
        }
      },
      {
        path: "contact",
        name: "Contact",
        components: {
          default: Contact
        }
      }
    ]
  }
];

export default routes;
